import React from 'react';
import { AuditProgramme } from '../types';

interface AuditProgrammeTabProps {
  programmes: AuditProgramme[];
  loading: boolean;
  onOpenCreate: () => void;
  onApproveProgramme: (id: string) => void;
}

export const AuditProgrammeTab: React.FC<AuditProgrammeTabProps> = ({
  programmes,
  loading,
  onOpenCreate,
  onApproveProgramme,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' }}>
            Annual Audit Programmes
          </h2>
          <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>
            Annual audit schedules covering operational and support departments pursuant to EASA & ISO 9001.
          </p>
        </div>
        <button
          onClick={onOpenCreate}
          className="btn-primary"
          style={{ width: 'auto', padding: '8px 16px', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
        >
          <span>+ New Annual Programme</span>
        </button>
      </div>

      {!loading && programmes.length === 0 ? (
        <div className="card" style={{ padding: '48px', textAlign: 'center', color: '#64748b' }}>
          No audit programmes registered.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {programmes.map((prog) => (
            <div
              key={prog.id}
              className="card"
              style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <span style={{ fontFamily: 'monospace', fontSize: '12px', fontWeight: 700, color: '#0284c7', background: '#e0f2fe', padding: '2px 8px', borderRadius: '4px' }}>
                      {prog.programmeNumber}
                    </span>
                    <h3 style={{ fontWeight: 700, color: '#0f172a', fontSize: '16px', margin: 0 }}>{prog.title}</h3>
                    <span className={prog.status === 'APPROVED' ? 'badge-pill badge-success' : 'badge-pill badge-info'}>
                      {prog.status}
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#64748b', marginTop: '6px' }}>
                    Year: <span style={{ fontWeight: 600, color: '#334155' }}>{prog.year}</span> | Period:{' '}
                    {prog.periodStart} ~ {prog.periodEnd} | Owner:{' '}
                    <span style={{ fontWeight: 600, color: '#334155' }}>{prog.ownerId}</span>
                  </div>
                </div>

                {prog.status !== 'APPROVED' && (
                  <button
                    onClick={() => onApproveProgramme(prog.id)}
                    className="btn-primary"
                    style={{ width: 'auto', padding: '6px 14px', fontSize: '12px', background: '#10b981', borderColor: '#059669' }}
                  >
                    ✓ Approve Programme (Director Signoff)
                  </button>
                )}
              </div>

              {prog.items && prog.items.length > 0 && (
                <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', background: '#f8fafc', padding: '14px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <h4 style={{ fontSize: '11px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>
                    Planned Audit Items ({prog.items.length})
                  </h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '10px' }}>
                    {prog.items.map((it) => (
                      <div
                        key={it.id}
                        style={{ background: '#ffffff', padding: '10px 14px', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                      >
                        <div>
                          <div style={{ fontWeight: 600, color: '#1e293b' }}>{it.targetDepartment}</div>
                          <div style={{ fontSize: '11px', color: '#64748b' }}>{it.targetDomain}</div>
                        </div>
                        <span style={{ fontFamily: 'monospace', fontSize: '11px', fontWeight: 700, color: '#0284c7', background: '#f0f9ff', padding: '2px 6px', borderRadius: '4px' }}>
                          {it.estimatedQuarter}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
